import { fromJS } from 'immutable';
import fromEntries from 'object.fromentries';

import {
  BAZEFIELD_FETCH_DATA_NEW,
  BAZEFIELD_FETCH_DATA_LOADING,
  BAZEFIELD_FETCH_DATA_LOADED,
  BAZEFIELD_FETCH_DATA_ERROR,
} from '../../actions/Bazefield';
import { MEASUREMENT_ID } from '../../config/constants';

const initialState = fromJS({
  status: BAZEFIELD_FETCH_DATA_NEW,
  measurements: {},
  error: null,
});

if (!Object.fromEntries) {
  fromEntries.shim();
}

export default function bazefield(state = initialState, action = {}) {
  switch (action.type) {
    case BAZEFIELD_FETCH_DATA_LOADING: {
      return state.merge(fromJS({
        status: action.type,
        // measurements: {},
        error: null,
      }));
    }

    case BAZEFIELD_FETCH_DATA_LOADED: {
      // Determine how much to cut of the keys.
      const start = MEASUREMENT_ID.length + 1;

      // Flatten the measurements.
      const measurements = Object.fromEntries(action.measurements.map((value) => [
        value.measurementName.substring(start),
        { value: value.value.v, unit: value.unit },
      ]));

      return state.merge(fromJS({
        status: action.type,
        measurements: measurements,
        error: null,
      }));
    }

    case BAZEFIELD_FETCH_DATA_ERROR: {
      return state.merge(fromJS({
        status: action.type,
        // measurements: {},
        error: action.error,
      }));
    }

    default:
      return state;
  }
}
